import React from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import EligibilityForm from "./components/EligibilityForm";
import HowItWorks from "./components/HowItWorks";
import WhyCreditGO from "./components/WhyCreditGO";
import FAQ from "./components/FAQ";

function App() {
  return (
    <div className="min-h-screen bg-background-light font-sans">
      <Header />
      <main>
        <Hero />
        <EligibilityForm />
        <HowItWorks />
        <WhyCreditGO />
        <FAQ />
      </main>
    </div>
  );
}

export default App;
